module.exports = "/_next/static/images/027a187e9360e383badffc6f919cdf47-security.jpg";